import log from 'salvo-lite/log'
import { WOW } from 'wowjs'

class Wow {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const wow = new WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 100,
            mobile: true,
            live: true,
            callback: function (box) {
            },
            scrollContainer: null
        })
        wow.init()
        document.addEventListener('masonry-update', e => {
            wow.sync()
        })
    }
}

export default Wow



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Wow.js